// extracted by mini-css-extract-plugin
export default {"scrollBody":"WhatsNewModal_scrollBody__zlXlr"};